import { Link } from "react-router-dom";
import PrivateImg from "../assets/HomeCare.jpg";
import CommunityImg from "../assets/CCPProgram.jpg";

export default function ServicesOverview() {
  return (
    <div className="bg-gray-50">  

      {/* ✅ What We Offer */}
      <section className="py-12 text-center">
        <h2 className="text-3xl font-bold text-gray-800 mb-8">What We Offer</h2>

        <div className="grid md:grid-cols-2 gap-10 max-w-6xl mx-auto">
          {/* ✅ Private Home Care Card */}
          <div className="p-6 bg-white rounded-lg shadow hover:shadow-lg transition">
            <img src={PrivateImg} alt="Private Home Care" className="w-full rounded-md" />
            <h3 className="text-xl font-semibold mt-4 text-blue-900">Private Home Care Services</h3>
            <ul className="mt-3 text-gray-700 text-left list-disc list-inside">
              <li>Home Support Services</li>
              <li>Personal Care Assistance</li>
              <li>Companionship & Social Engagement</li>
              <li>Respite Care</li>
              <li>Transportation & Errands</li>
            </ul>
            <Link 
              to="/private-home-care"
              className="inline-block mt-5 px-6 py-2 bg-[#0B2B55] text-white rounded-md shadow hover:bg-blue-900 transition"
            >
              Know More
            </Link>
          </div>

          {/* ✅ Community Care Card */}
          <div className="p-6 bg-white rounded-lg shadow hover:shadow-lg transition">
            <img src={CommunityImg} alt="Community Care Program" className="w-full rounded-md" />
            <h3 className="text-xl font-semibold mt-4 text-blue-900">Community Care Services</h3>
            <p className="mt-3 text-gray-700 text-sm leading-relaxed">
              We collaborate with local Managed Care Organizations like Illinois Department on Aging,
              Aetna, Humana, Blue Cross Blue Shield, Illinicare and County Care for our Community Care Program.
            </p>
            <Link 
              // to="/ccp-home-care"
              to="/Community-Care-Program"
              className="inline-block mt-5 px-6 py-2 bg-[#0B2B55] text-white rounded-md shadow hover:bg-blue-900 transition"
            >
              Know More
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
